import { makeStyles } from "@material-ui/core/styles";

const DARK = "#263238";
const DARK_HOVER = "#1c262b";

export default makeStyles((theme) => ({
  analyze: {
    backgroundColor: DARK,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: DARK_HOVER,
    },
    "&.Mui-disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.26)",
    },
  },
}));
